import { usePage } from "../hooks/CmsHooks";
import { BreadcrumbItem } from "./Breadcrumbs";

const BreadcrumbPageItem = ({ path }, key) => {
  const page = usePage(path);
  return <BreadcrumbItem key={key} url={path} text={page.title} />;
};

export default BreadcrumbPageItem;
